import { Check } from 'lucide-react';
import { cn } from '../../lib/cn';
import { Icon } from '../ui/icon';

export interface SchritteProps {
  /** Beschriftungen in Reihenfolge, je ein bis zwei Wörter: „Datei“, „Zuordnung“, „Übernahme“. */
  schritte: string[];
  /** Index des aktuellen Schritts. Alles davor gilt als erledigt. */
  aktuell: number;
  className?: string;
}

/**
 * Wo man in einem Ablauf aus wenigen Schritten steht. Erledigtes mit Haken in
 * `selection`, der aktuelle Schritt in `highlight`, Kommendes zurückgenommen.
 * Nur Anzeige: Die Schritte sind keine Knöpfe.
 */
export function Schritte({ schritte, aktuell, className }: SchritteProps) {
  return (
    <ol className={cn('flex flex-wrap items-center gap-x-2 gap-y-1.5', className)}>
      {schritte.map((name, i) => {
        const zustand = i < aktuell ? 'erledigt' : i === aktuell ? 'aktuell' : 'kommt';
        return (
          <li key={name} aria-current={zustand === 'aktuell' ? 'step' : undefined} className="flex items-center gap-2">
            <span
              aria-hidden
              className={cn(
                'flex size-6 shrink-0 items-center justify-center rounded-full border t-small font-medium tabular',
                zustand === 'erledigt' && 'border-selection bg-selection text-selection-foreground',
                zustand === 'aktuell' && 'border-ring bg-highlight-soft text-highlight',
                zustand === 'kommt' && 'border-input bg-card text-muted-foreground',
              )}
            >
              {zustand === 'erledigt' ? <Icon icon={Check} size={13} strokeWidth={2.5} /> : i + 1}
            </span>
            <span className={zustand === 'aktuell' ? 't-body-strong text-foreground' : 't-body text-muted-foreground'}>
              <span className="sr-only">{zustand === 'erledigt' ? 'Erledigt: ' : zustand === 'aktuell' ? 'Aktuell: ' : ''}</span>
              {name}
            </span>
            {i < schritte.length - 1 && <span aria-hidden className="h-px w-6 bg-border sm:w-8" />}
          </li>
        );
      })}
    </ol>
  );
}
